import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import "../newContent/page/styles/newSideBarApplication.css"

const FLOW_STEPS = [
    {
        id: "personal",
        type: "Personal",
        list: [
            { id: "yourinfo", menu: "Your info", section: "yourinfo" },
            { id: "residence", menu: "Current residence", section: "residence" },
        ],
    },
    {
        id: "property",
        type: "Subject property",
        section: "property",
        list: [],
    },
    {
        id: "income",
        type: "Income",
        list: [
            { id: "employment", menu: "Employment", section: "employment" },
            { id: "otherincome", menu: "Other income", section: "otherincome" },
        ],
    },
    {
        id: "finance",
        type: "Finance",
        list: [
            { id: "assets", menu: "Assets", section: "assets" },
            { id: "realestate", menu: "Real estate", section: "realestate" },
            { id: "liabilities", menu: "Liabilities", section: "liabilities" },
        ],
    },
    {
        id: "declarations",
        type: "Declarations",
        list: [
            { id: "propertymoney", menu: "Property & money", section: "propertymoney" },
            { id: "finances", menu: "Finances", section: "finances" },
            { id: "creditcheck", menu: "Credit check", section: "creditcheck" },
        ],
    },
]

const getGroupStatus = (step, completedSteps) => {
    if (!step.list.length) {
        const completed = !!completedSteps[step.id]
        return { allCompleted: completed, someCompleted: completed }
    }
    const values = step.list.map((item) => !!completedSteps[item.id])
    return {
        allCompleted: values.every(Boolean),
        someCompleted: values.some(Boolean),
    }
}

const StepCircleIcon = ({ step, completedSteps }) => {
    const { allCompleted, someCompleted } = getGroupStatus(step, completedSteps)
    if (allCompleted) {
        return (
            <div className="step-green-circle">
                <img src="/images/sidebaricons/green-check-mark.svg" alt="completed" />
            </div>
        )
    }
    if (someCompleted) {
        return (
            <div className="step-blue-circle">
                <div className="step-center-dot" />
            </div>
        )
    }
    return <div className="step-gray-circle" />
}

const StepApplicationV2 = ({ activePartyId, activeSection = "yourinfo", completedSteps = {} }) => {
    const [subMenuVisibility, setSubMenuVisibility] = useState({
        personal: true,
        property: false,
        income: false,
        finance: false,
        declarations: false,
    })

    const activeGroupId = useMemo(() => {
        const group = FLOW_STEPS.find((step) => (
            step.section === activeSection || step.list.some((item) => item.section === activeSection)
        ))
        return group?.id || "personal"
    }, [activeSection])

    useEffect(() => {
        setSubMenuVisibility((prev) => ({ ...prev, [activeGroupId]: true }))
    }, [activeGroupId])

    const toPath = (section) => `/application/v2/interview/${section}/${activePartyId}`

    return (
        <div className="step-menu-container">
            {FLOW_STEPS.map((item) => {
                const isActiveGroup = activeGroupId === item.id
                const { allCompleted, someCompleted } = getGroupStatus(item, completedSteps)
                const groupColor = isActiveGroup && !allCompleted
                    ? "#325CEB"
                    : allCompleted
                        ? "#2E605A"
                        : someCompleted ? "#222222" : "#586570"

                return (
                    <div key={item.id}>
                        <div className="step-menu-item" style={{ marginBottom: "16px" }}>
                            <StepCircleIcon step={item} completedSteps={completedSteps} />
                            <div style={{ marginLeft: "12px" }}>
                                <Link
                                    className="step-menu-text"
                                    to={toPath(item.section || item.list[0].section)}
                                    onClick={(e) => {
                                        if (item.list.length) {
                                            e.preventDefault()
                                            setSubMenuVisibility((prev) => ({ ...prev, [item.id]: !prev[item.id] }))
                                        }
                                    }}
                                    style={{ color: groupColor }}
                                >
                                    {item.type}
                                </Link>
                            </div>
                        </div>
                        {item.list.length > 0 && subMenuVisibility[item.id] && (
                            <div className="sub-menu-container">
                                {item.list.map((subItem) => (
                                    <div key={subItem.id} className="sub-menu-item">
                                        <Link
                                            to={toPath(subItem.section)}
                                            style={{
                                                fontSize: "16px",
                                                fontWeight: activeSection === subItem.section ? 500 : 400,
                                                color: activeSection === subItem.section ? "#325CEB" : "#586570",
                                            }}
                                        >
                                            {subItem.menu}
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default StepApplicationV2
